import { render, staticRenderFns } from "./CreateAddress.vue?vue&type=template&id=3792e2e0&scoped=true&"
import script from "./CreateAddress.vue?vue&type=script&lang=js&"
export * from "./CreateAddress.vue?vue&type=script&lang=js&"
import style0 from "./CreateAddress.vue?vue&type=style&index=0&id=3792e2e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3792e2e0",
  null
  
)

export default component.exports